// src/hooks/useEmailVerification.js
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "../../../services/axiosInstance";

export function useEmailVerification() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const token = searchParams.get("token");

  const verify = async () => {
    if (!token) {
      setStatus("error");
      setMessage("Không tìm thấy mã xác minh.");
      return;
    }

    setStatus("loading");

    try {
      const { data } = await axiosInstance.get("/auth/verify-email", {
        params: { token },
      });
      setStatus("success");
      setMessage(data.message);
    } catch (err) {
      setStatus("error");
      setMessage(
        err?.response?.data?.message ?? "Mã xác minh không hợp lệ hoặc đã hết hạn."
      );
    }
  };

  return { status, message, verify };
}